"use client";

import Image from "next/image";
import Link from "next/link";

import Logo from "../Logo";
import ContactButton from "./ContactButton";
const styles = new Proxy({"Navbar":"Navbar-4b20b","Cursor":"Cursor-4b20b","ContactButton":"ContactButton-4b20b"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Mobilemenu.scss";*/
import { Fragment } from "react";

export type MenuItem = {
  label: string;
  sublabel?: string;
  url: string;
  type: string;
  items?: Record<string, MenuItem[]>;
};

const cursor = "/images/cursor.svg";

const Navbar = ({ items }: { items: MenuItem[] }) => {
  return (
    <div className="container">
      <nav
        className={`navbar fixed-top navbar-expand-lg navbar-dark ${styles.Navbar}`}
      >
        <div className="container">
          <Link href="/" className="navbar-brand">
            <span className={styles.NavLogo}>
              <Logo />
            </span>
          </Link>

          <input
            id="menu__toggle"
            type="checkbox"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          />
          <label className="menu__btn" htmlFor="menu__toggle">
            <span></span>
          </label>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav d-flex align-items-lg-center mx-auto mb-2 mb-lg-0">
              {items.map((item, index) => (
                <li
                  key={index}
                  className={
                    "nav-item mx-0 mx-lg-3" +
                    (index > 0 &&
                    item.items &&
                    Object.keys(item.items).length > 0
                      ? " position-relative"
                      : "")
                  }
                >
                  <Link href={item.url} className="nav-link">
                    {item.label}
                  </Link>
                  {item.items && Object.keys(item.items).length > 0 && (
                    <ul>
                      {Object.entries(item.items).map(
                        ([group, subitems], subindex) => (
                          <div key={subindex} style={{ minWidth: "200px" }}>
                            <li key={subindex}>
                              <h5>{group}</h5>
                              {subitems.map((subitem, subitemIndex) => (
                                <Fragment key={subitemIndex}>
                                  <a
                                    key={subitemIndex}
                                    href={subitem.url}
                                    rel={
                                      subitem.type === "link"
                                        ? "noreferrer"
                                        : undefined
                                    }
                                    target={
                                      subitem.type === "link"
                                        ? "_blank"
                                        : undefined
                                    }
                                  >
                                    {subitem.label}
                                  </a>
                                  {(subitem.sublabel?.length ?? 0) > 0 ? (
                                    <span>{subitem.sublabel}</span>
                                  ) : null}
                                </Fragment>
                              ))}
                            </li>
                          </div>
                        ),
                      )}
                    </ul>
                  )}
                </li>
              ))}
            </ul>

            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item text-center">
                <ContactButton className={styles.ContactButton} />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
